// removed by extract-text-webpack-plugin
module.exports = {"white":"color__white___1SJ9j borderColor-white borderRightColor-transparent","smoke":"color__smoke___35Of1 borderColor-smoke borderRightColor-transparent","darkSmoke":"color__darkSmoke___j493w borderColor-smoke--d borderRightColor-transparent","silver":"color__silver___2GAUx borderColor-silver borderRightColor-transparent","blue":"color__blue___3N6dr borderColor-blue borderRightColor-transparent"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-loader/Loader/style/color.css
// module id = 8
// module chunks = 0 1 2 10 19